import { useColor } from '../composables/helpers/color'
import type {
  ColorOverrides,
  TColorOverrideValue,
  THexColor,
} from '../types/PrevioDesignSystemOptions'

const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i

const isHexColor = (value: TColorOverrideValue): value is THexColor => value.startsWith('#')

const resolve = (key: string, value: TColorOverrideValue): string => {
  if (isHexColor(value)) {
    if (!HEX_COLOR.test(value)) {
      throw new Error(`Color override "${key}": "${value}" is not a valid hex color`)
    }

    return value
  }

  if (value === key) {
    throw new Error(`Color override "${key}" points at itself`)
  }

  return useColor().getCssVarByColor(value)
}

export const applyColorOverrides = (colors?: ColorOverrides): void => {
  if (!colors) {
    return
  }

  const root = document.documentElement

  for (const [key, value] of Object.entries(colors)) {
    root.style.setProperty(`--color-${key}`, resolve(key, value))
  }
}
